import { Avatar, Button, Checkbox, Grid, Group, Loader, Paper, Popover, Progress, Text, Title, UnstyledButton } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { showNotification } from '@mantine/notifications';
import {
    ArcElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, LineElement, PointElement, Title as TitleChart,
    Tooltip
} from 'chart.js';
import moment from 'moment';
import React from 'react';
import { Pie } from 'react-chartjs-2';
import { FaBell, FaBirthdayCake, FaCalendar, FaInfoCircle } from 'react-icons/fa';
import InputField, { InputFieldTypes } from '../components/input_field';
import { useAuth } from '../contexts/auth.context';
import { CREATE_PAGE } from '../services/pages';
import { BasicFilter, THEMES_BY_POSITION, THEMES_BY_PRIORITY } from '../services/statistics';

const colors = [
    'rgba(255, 99, 132, 1)',
    'rgba(54, 162, 235, 1)',
    'rgba(255, 206, 86, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(153, 102, 255, 1)',
    'rgba(255, 159, 64, 1)',
];
  
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    ArcElement,
    TitleChart,
    Tooltip,
    Legend
);

export default function Home(){
    // const [period, setPeriod] = React.useState([
    //     moment().startOf("week").toDate(),
    //     moment().endOf("week").toDate(),
    // ]);
    const [filter, setFilter] = React.useState<BasicFilter>({});
    const [reportOpen, setReportOpen] = React.useState<string>(null);
    const [reportParams, setReportParams] = React.useState<any>({});
    const [loadingEmit, setLoadingEmit] = React.useState<boolean>(false);

    const isMobile = useMediaQuery('(max-width: 900px)');
    
    const {role} = useAuth();

    const emitReport = () => {
        try{
            if(reportOpen === "agenda" && (!reportParams.period || !reportParams.period[0] || !reportParams.period[1])) throw new Error("Selecione o período");
            if(reportOpen === "new_themes" && (!reportParams.created || !reportParams.created[0] || !reportParams.created[1])) throw new Error("Selecione o período");
            if(reportOpen === "tramitation" && (!reportParams.period || !reportParams.period[0] || !reportParams.period[1])) throw new Error("Selecione o período");
            setLoadingEmit(true)
            
            CREATE_PAGE(reportOpen, {
                companyId: role.company._id,
                ...reportParams,
            })
            .then((page : any) => {
                setLoadingEmit(false);
                setReportOpen(null);
                setReportParams({});
                window.open(`/${page.uuid}`, "_blank");
            })
            .catch(err => {
                setLoadingEmit(false);
                showNotification({title: "Ops", message: err.message, color: 'red'});
            })
        }catch(err){
            showNotification({title: "Ops", message: err.message, color: 'red'});
        }
    }

    return <>
        <Grid>
            {/* <Grid.Col lg={4} sm={12}>
                <Card shadow="sm" p="xs">
                    <Title align="center">TOTAL</Title>
                    <Title align="center">{(dtPeriod || []).length}</Title>
                </Card>
            </Grid.Col>
            <Grid.Col lg={4} sm={12}>
                <Card shadow="sm" p="xs">
                    <Title align="center">ESSA SEMANA</Title>
                    <Title align="center">{(dtPeriod || []).filter(item => moment(item.created_at).format("YYYY-MM-DD") >= moment().startOf("week").format("YYYY-MM-DD")).length}</Title>
                </Card>
            </Grid.Col>
            <Grid.Col lg={4} sm={12}>
                <Card shadow="sm" p="xs">
                    <Title align="center">ESSE MÊS</Title>
                    <Title align="center">{(dtPeriod || []).filter(item => moment(item.created_at).format("YYYY-MM-DD") >= moment().startOf("month").format("YYYY-MM-DD")).length}</Title>
                </Card>
            </Grid.Col> */}
            <Grid.Col md={4} sm={6}>
                <Paper shadow="sm" p="xs">
                    <ThemesByPosition
                        filter={filter}
                    />
                </Paper>
            </Grid.Col>
            <Grid.Col md={4} sm={6}>
                <Paper shadow="sm" p="xs">
                    <ThemesByPriority/>
                </Paper>
            </Grid.Col>
            <Grid.Col md={4} sm={12}>
                <Paper shadow="sm" p="xs">
                <Popover
                    position={isMobile ? "top" : "left"}
                    opened={reportOpen === 'agenda'}
                    withArrow
                    width={350}
                >
                    <Popover.Target>
                        <UnstyledButton onClick={() => setReportOpen("agenda")}>
                            <Group>
                                <Avatar size={40} color="blue"><FaCalendar /></Avatar>
                                <div>
                                    <Text>Agenda</Text>
                                    <Text size="xs" color="dimmed">Clique para emitir o relatório</Text>
                                </div>
                            </Group>
                        </UnstyledButton>
                    </Popover.Target>
                    <Popover.Dropdown>
                        <Title order={4} mb="md">Agenda - Emitir relatório</Title>
                        <InputField
                            title="Casas"
                            name="origins"
                            type={InputFieldTypes.SELECT}
                            multiple
                            mb="md"
                            value={(reportParams.origins ?? [])}
                            options={[
                                { value: "senado", label: "Senado Federal" },
                                { value: "camara", label: "Câmara dos Deputados" },
                            ]}
                            onChange={({origins}) => setReportParams(rp => ({ ...rp, origins }))}
                        />
                        <InputField
                            title="Período"
                            name="period"
                            type={InputFieldTypes.DATERANGE}
                            value={(reportParams.period || []).map(p => p ? moment(p).toDate() : null)}
                            onChange={({period}) => setReportParams(rp => ({
                                ...rp, period: period.map(p => p ? moment(p).format("YYYY-MM-DD") : null)
                            }))}
                        />

                        <div style={{textAlign: 'right', padding: '20px 0 0 0'}}>
                            <Button loading={loadingEmit} onClick={() => setReportOpen(null)} mr="md" variant='outline'>Cancelar</Button>
                            <Button loading={loadingEmit} onClick={emitReport}>Emitir</Button>
                        </div>
                    </Popover.Dropdown>
                </Popover>
                <Popover
                    position={isMobile ? "top" : "left"}
                    opened={reportOpen === 'new_themes'}
                    withArrow
                    width={350}
                >
                    <Popover.Target>
                        <UnstyledButton mt="md" onClick={() => setReportOpen("new_themes")}>
                            <Group>
                                <Avatar size={40} color="blue"><FaInfoCircle /></Avatar>
                                <div>
                                    <Text>Novas pautas</Text>
                                    <Text size="xs" color="dimmed">Clique para emitir o relatório</Text>
                                </div>
                            </Group>
                        </UnstyledButton>
                    </Popover.Target>
                    <Popover.Dropdown>
                        <Title order={4} mb="md">Novas pautas - Emitir relatório</Title>
                        <Paper p="md">
                            <Checkbox
                                onChange={e => setReportParams(rp => ({...rp, withInteractions: e.target.checked}))}
                                checked={reportParams.withInteractions}
                                label="Pautas que estou acompanhando"
                            />
                        </Paper>
                        
                        <Paper p="md">
                            <Checkbox
                                onChange={e => setReportParams(rp => ({...rp, keywords: e.target.checked}))}
                                checked={reportParams.keywords}
                                label="Baseado em minhas palavras-chave"
                            />
                        </Paper>
                        <InputField
                            title="Período de criação"
                            name="period"
                            type={InputFieldTypes.DATERANGE}
                            value={(reportParams.created || []).map(p => p ? moment(p).toDate() : null)}
                            onChange={({period}) => setReportParams(rp => ({
                                ...rp,
                                created: period.map(p => p ? moment(p).format("YYYY-MM-DD") : null),
                            }))}
                        />

                        <div style={{textAlign: 'right', padding: '20px 0 0 0'}}>
                            <Button loading={loadingEmit} onClick={() => setReportOpen(null)} mr="md" variant='outline'>Cancelar</Button>
                            <Button loading={loadingEmit} onClick={emitReport}>Emitir</Button>
                        </div>
                    </Popover.Dropdown>
                </Popover>
                <Popover
                    position={isMobile ? "top" : "left"}
                    opened={reportOpen === 'tramitation'}
                    withArrow
                    width={350}
                >
                    <Popover.Target>
                        <UnstyledButton mt="md" onClick={() => setReportOpen("tramitation")}>
                            <Group>
                                <Avatar size={40} color="blue"><FaBell /></Avatar>
                                <div>
                                    <Text>Tramitações</Text>
                                    <Text size="xs" color="dimmed">Clique para emitir o relatório</Text>
                                </div>
                            </Group>
                        </UnstyledButton>
                    </Popover.Target>
                    <Popover.Dropdown>
                        <Title order={4} mb="md">Tramitações - Emitir relatório</Title>
                        <Paper p="md">
                            <Checkbox
                                onChange={e => setReportParams(rp => ({...rp, withInteractions: e.target.checked}))}
                                checked={reportParams.withInteractions}
                                label="Pautas que estou acompanhando"
                            />
                        </Paper>
                        
                        <Paper p="md">
                            <Checkbox
                                onChange={e => setReportParams(rp => ({...rp, keywords: e.target.checked}))}
                                checked={reportParams.keywords}
                                label="Baseado em minhas palavras-chave"
                            />
                        </Paper>
                        <InputField
                            title="Período"
                            name="period"
                            type={InputFieldTypes.DATERANGE}
                            value={(reportParams.period || []).map(p => p ? moment(p).toDate() : null)}
                            onChange={({period}) => setReportParams(rp => ({
                                ...rp,
                                period: period.map(p => p ? moment(p).format("YYYY-MM-DD") : null),
                            }))}
                        />

                        <div style={{textAlign: 'right', padding: '20px 0 0 0'}}>
                            <Button loading={loadingEmit} onClick={() => setReportOpen(null)} mr="md" variant='outline'>Cancelar</Button>
                            <Button loading={loadingEmit} onClick={emitReport}>Emitir</Button>
                        </div>
                    </Popover.Dropdown>
                </Popover>
                <Popover
                    position={isMobile ? "top" : "left"}
                    opened={reportOpen === 'birthdays'}
                    withArrow
                    width={350}
                >
                    <Popover.Target>
                        <UnstyledButton mt="md" onClick={() => setReportOpen("birthdays")}>
                            <Group>
                                <Avatar size={40} color="blue"><FaBirthdayCake /></Avatar>
                                <div>
                                    <Text>Aniversariantes</Text>
                                    <Text size="xs" color="dimmed">Clique para emitir o relatório</Text>
                                </div>
                            </Group>
                        </UnstyledButton>
                    </Popover.Target>
                    <Popover.Dropdown>
                        <Title order={4} mb="md">Aniversariantes - Emitir relatório</Title>
                        <InputField
                            title="Status"
                            name="activity"
                            type={InputFieldTypes.SELECT}
                            value={reportParams.activity}
                            clearable={false}
                            options={[
                                { label: "Todos", value: "all" },
                                { label: "Em exercício", value: "active" },
                                { label: "Inativos", value: "inactive" },
                            ]}
                            onChange={dt => setReportParams(f => ({...f, ...dt}))}
                        />
                        <InputField
                            title="Período de aniversário"
                            name="period"
                            type={InputFieldTypes.DATERANGE}
                            value={(reportParams.range || []).map(p => p ? moment(p).toDate() : null)}
                            onChange={({period}) => setReportParams(rp => ({
                                ...rp,
                                range: period.map(p => p ? moment(p).format("YYYY-MM-DD") : null),
                            }))}
                        />

                        <div style={{textAlign: 'right', padding: '20px 0 0 0'}}>
                            <Button loading={loadingEmit} onClick={() => setReportOpen(null)} mr="md" variant='outline'>Cancelar</Button>
                            <Button loading={loadingEmit} onClick={emitReport}>Emitir</Button>
                        </div>
                    </Popover.Dropdown>
                </Popover>

                </Paper>
            </Grid.Col>
        </Grid>
    </>
}

interface ThemesByPositionProps{
    filter?: BasicFilter;
}
interface ThemesByPriorityProps{
    filter?: BasicFilter;
}

const ThemesByPosition = (props: ThemesByPositionProps) => {
    const { filter } = props;
    const [data, setData] = React.useState<any[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    
    React.useEffect(() => {
        setLoading(true);
        THEMES_BY_POSITION(filter)
        .then(res => {
            setLoading(false);
            setData(res);
        })
        .catch((err) => {
            setLoading(false);
            showNotification({message: err.message, color: 'red', title: 'Ops'});
        })
    }, [filter])

    if(loading) return <Loader />;
    return <>
        <Pie
            options={{
                responsive: true,
                plugins: {
                    legend: { position: 'top' as const },
                    title: { display: true, text: 'Posicionamentos' },
                },
            }}
            data={{
                
                labels: data.map(d => `${d.value} - ${d.label}`),
                datasets: [
                    {
                        label: 'Data',
                        data: data.map(d => d.value),
                        backgroundColor: [
                            'rgba(255, 99, 132, 0.2)',
                            'rgba(54, 162, 235, 0.2)',
                            'rgba(255, 206, 86, 0.2)',
                            'rgba(75, 192, 192, 0.2)',
                            'rgba(153, 102, 255, 0.2)',
                            'rgba(255, 159, 64, 0.2)',
                        ],
                        borderColor: colors,
                    }
                ]
            }}
        />
        {/* <Progress
            size="lg"
            sections={data.map((d, i) => ({value: d.value, label: d.label, color: colors[i%colors.length]}))}
        /> */}
    </>;
}

const ThemesByPriority = (props: ThemesByPriorityProps) => {
    const { filter } = props;
    const [data, setData] = React.useState<any[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    
    React.useEffect(() => {
        setLoading(true);
        THEMES_BY_PRIORITY(filter)
        .then(res => {
            setLoading(false);
            setData(res);
        })
        .catch((err) => {
            setLoading(false);
            showNotification({message: err.message, color: 'red', title: 'Ops'});
        })
    }, [filter])

    if(loading) return <Loader />;
    return <Pie
        options={{
            responsive: true,
            plugins: {
                legend: { position: 'top' as const },
                title: { display: true, text: 'Prioridades' },
            },
        }}
        data={{
            
            labels: data.map(d => `${d.value} - ${d.label}`),
            datasets: [
                {
                    label: 'Data',
                    data: data.map(d => d.value),
                    backgroundColor: [
                        'rgba(255, 99, 132, 0.2)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(255, 159, 64, 0.2)',
                    ],
                    borderColor: [
                        'rgba(255, 99, 132, 1)',
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 206, 86, 1)',
                        'rgba(75, 192, 192, 1)',
                        'rgba(153, 102, 255, 1)',
                        'rgba(255, 159, 64, 1)',
                    ],
                }
            ]
        }}
    />;
}
